import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
export default {
  name: 'd2-cascader',
  props: {
    item: {
      type: Object
    }
  },
  data: function data() {
    return {
      props: {
        label: 'typeName',
        value: 'goodsTypeId',
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    };
  },
  methods: {
    lazyLoad: function lazyLoad(node, resolve) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var level, data, obj, _yield$_this$$api$_th, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                level = node.level, data = node.data;
                obj = {
                  typeLevel: level + 1,
                  preTypeId: data === null || data === void 0 ? void 0 : data.goodsTypeId
                };
                _context.next = 4;
                return _this.$api[_this.item.api](obj, resolve);

              case 4:
                _yield$_this$$api$_th = _context.sent;
                records = _yield$_this$$api$_th.records;
                resolve(records);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeCascader: function changeCascader(e) {
      var _this2 = this;

      if (e && e.length > 0) {
        this.item.values.forEach(function (v, i) {
          _this2.$attrs.searchForm[v] = e[i];
        });
      } else {
        this.item.values.forEach(function (v) {
          delete _this2.$attrs.searchForm[v];
        });
      }
    }
  }
};